// @mui
import type { BoxProps } from '@mui/material';
import type { MotionProps } from 'framer-motion';

import { Box } from '@mui/material';
import { m } from 'framer-motion';

//
import { varContainer } from './variants';

// ----------------------------------------------------------------------

export interface Props extends IProps {
  action?: boolean;
  animate?: boolean;
}

type IProps = BoxProps & MotionProps;

const MotionContainer = ({
  action = false,
  animate,
  children,
  ...other
}: Props) => {
  if (action) {
    return (
      <Box
        animate={animate ? 'animate' : 'exit'}
        component={m.div}
        initial={false}
        variants={varContainer()}
        {...other}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      animate="animate"
      component={m.div}
      exit="exit"
      initial="initial"
      variants={varContainer()}
      {...other}
    >
      {children}
    </Box>
  );
};

export default MotionContainer;
